import React from 'react'
import { AnchorLinkToExamDetails, Container, ContainerInformation } from './styles'
import { ModalHeader } from '../../ModalComponents/ModalHeader'
import { ModalLongInformations } from '../../ModalComponents/ModalLongInformations'
import { ReferringPhysicianDetails } from '../../ReferringPhysicianDetails'
import { IconComponent } from '~/assets/icons/component'
import { IAnatomopathologicalTest } from '~/interfaces'

interface AnatomopathologicalTestDetailsContentProps {
  anatomopathologicalTestData: IAnatomopathologicalTest
}

export const AnatomopathologicalTestDetailsContent = ({
  anatomopathologicalTestData
}: AnatomopathologicalTestDetailsContentProps): JSX.Element => {
  const { startDate, description, referringPhysician, report, reportLink } = anatomopathologicalTestData
  return (
    <Container>
      <ModalHeader title={description} datetime={startDate} />
      <ContainerInformation>
        <ReferringPhysicianDetails physician={referringPhysician} />
        <hr />
        {report &&
          report?.length > 0 &&
          report.map(_data => (
            <ModalLongInformations key={_data.title} label={_data.title} valueHTML={_data.content} />
          ))}

        {reportLink ? (
          <AnchorLinkToExamDetails href={reportLink} target="blank">
            <IconComponent name="arrowUpRightFromSquare" />
            <span>Visualizar Laudo</span>
          </AnchorLinkToExamDetails>
        ) : null}
      </ContainerInformation>
    </Container>
  )
}
